<template>
  <div>
    <div class="card-box">
      <div class="mapBox">
        <div id="map" ref="mapdt"></div>
      </div>
      <div class="table-box listBox">
        <global-tag>
          <el-form
            class="queryForm"
            ref="queryForm"
            :model="queryForm"
            label-width="130px"
          >
            <div style="display: flex">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="工单流水号：">
                    <el-input
                      clearable
                      v-model="queryForm.orderNum"
                      placeholder="请输入工单号"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="客户姓名：">
                    <el-input
                      clearable
                      v-model="queryForm.customerName"
                      placeholder="请输入客户姓名"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="身份证：">
                    <el-input
                      clearable
                      placeholder="请输入身份证号"
                      v-model="queryForm.idCard"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="手机号：">
                    <el-input
                      placeholder="请输入手机号"
                      clearable
                      v-model="queryForm.customerphone"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="服务人员姓名：">
                    <el-input
                      placeholder="请输入服务人员姓名"
                      clearable
                      v-model="queryForm.servePersonName"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="服务人员手机号：">
                    <el-input
                      placeholder="请输入手机号"
                      clearable
                      v-model="queryForm.servePersonPhone"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="工单号：">
                    <el-input
                      placeholder="请输入工单号"
                      clearable
                      v-model="queryForm.orderNum"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <!-- 增加筛选条件 -->
                <el-col :span="23">
                  <el-form-item label="地址：">
                    <el-select
                      v-model="queryForm.provinceId"
                      placeholder="请选择省"
                      @change="handleProvince"
                      ref="selectShengChange"
                      class="address"
                    >
                      <el-option
                        v-for="(item, index) in provinceList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode"
                      >
                      </el-option>
                    </el-select>
                    <el-select
                      v-model="queryForm.cityid"
                      placeholder="请选择市"
                      @change="handleCity"
                      ref="selectShiChange"
                      class="address"
                    >
                      <el-option
                        v-for="(item, index) in cityList"
                        :key="index"
                        :label="item.addName"
                        :value="item.addCode"
                      >
                      </el-option>
                    </el-select>
                    <el-select
                      v-model="queryForm.zoneid"
                      placeholder="请选择区"
                      @change="handleArea"
                      ref="selectQuChange"
                      class="address"
                    >
                      <el-option
                        v-for="(item, index) in areaList"
                        :key="index"
                        :label="item.addName"
                        :value="item.addCode"
                      >
                      </el-option>
                    </el-select>
                    <el-select
                      v-model="queryForm.streetid"
                      placeholder="请选择街道"
                      @change="streetChange"
                      ref="selectJiedaoChange"
                      class="address"
                    >
                      <el-option
                        v-for="(item, index) in streetList"
                        :key="index"
                        :label="item.addName"
                        :value="item.addCode"
                      >
                      </el-option>
                    </el-select>
                    <el-select
                      v-model="queryForm.shequid"
                      placeholder="请选择社区"
                      ref="selectShequChange"
                      @change="handleCommunityChange"
                      class="address"
                    >
                      <el-option
                        v-for="item in communityList"
                        :key="item.addCode"
                        :label="item.addName"
                        :value="+item.addCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="14">
                  <el-form-item label="服务时间：">
                    <el-date-picker
                      v-model="queryForm.timeStart"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      clearable
                      type="datetime"
                      placeholder="请输入开始时间"
                    ></el-date-picker>
                    <span style="margin: 0 5px">至</span>
                    <el-date-picker
                      v-model="queryForm.timeEnd"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      clearable
                      type="datetime"
                      placeholder="请输入结束时间"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="2" class="QuerySearchBtn">
                  <el-button
                    size="medium"
                    type="primary"
                    @click="QuerySearch"
                    class="searchBtns"
                    style="width: 100%; margin-left: 10%"
                    >查询
                  </el-button>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </global-tag>
        <div class="">
          <div>
            <el-button-group>
              <el-button
                type="success"
                class="openBtns"
                icon="el-icon-plus"
                @click="addOpen"
                >工单异常类型
              </el-button>
            </el-button-group>
            <el-button-group>
              <el-button
                type="success"
                icon="el-icon-download"
                class="button downOutBtns"
                @click="createExcel"
                style="margin-left: 20px"
                >导出
              </el-button>
            </el-button-group>
            <el-button-group>
              <!-- 查看所有异常工单 -->
              <el-button
                :type="seeState"
                @click="whole"
                style="margin-left: 20px"
                >查询所有异常工单
              </el-button>
              <!-- 查看所有异常工单 -->
            </el-button-group>
          </div>
          <div style="margin-top: 10px">
            <el-table
              :data="tableData"
              border
              style="width: 100%"
              :header-cell-style="{
                background: '#f2f2f2',
                color: '#000',
              }"
              @current-change="tableChange"
            >
              <el-table-column
                type="index"
                width="70"
                label="序号"
                align="center"
                :show-overflow-tooltip="true"
                v-if="
                  this.tempTableChekbox.findIndex((item) => item == '序号') !=
                  -1
                "
              >
              </el-table-column>
              <el-table-column
                label="操作"
                align="center"
                :show-overflow-tooltip="true"
                width="150"
                v-if="
                  this.tempTableChekbox.findIndex((item) => item == '操作') !=
                  -1
                "
              >
                <template slot-scope="scope">
                  <div v-if="seeShow == false">
                    <!-- !scope.row.processStatus && -->
                    <!-- 点击处置 弹出-->

                    <el-button
                      v-if="scope.row.noHandleDays == 1"
                      class="cheng"
                      type="text"
                      @click="addOpens(scope.row)"
                      >处置
                    </el-button>
                    <!-- {{ scope.row.processStatus }} -->
                    <el-button
                      v-if="scope.row.noHandleDays == 2"
                      class="huang"
                      type="text"
                      @click="addOpens(scope.row)"
                      >处置
                    </el-button>
                    <!-- !scope.row.processStatus && -->
                    <el-button
                      v-if="scope.row.noHandleDays >= 3"
                      class="hong"
                      type="text"
                      @click="addOpens(scope.row)"
                      >处置
                    </el-button>
                    <!-- !scope.row.processStatus && -->
                    <el-button
                      v-if="
                        scope.row.noHandleDays == 0 || !scope.row.noHandleDays
                      "
                      class="lan"
                      type="text"
                      @click="addOpens(scope.row)"
                      >处置
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="exceptionStatus"
                label="异常类型"
                align="center"
                width="220"
                :show-overflow-tooltip="true"
                v-if="
                  this.tempTableChekbox.findIndex(
                    (item) => item == '异常类型'
                  ) != -1
                "
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.exceptionStatus == '1'">位置异常</span>
                  <span v-if="scope.row.exceptionStatus == '2'">时间异常</span>
                  <span v-if="scope.row.exceptionStatus == '3'"
                    >位置异常、时间异常</span
                  >
                  <span v-if="scope.row.exceptionStatus == '4'">回访异常</span>
                  <span v-if="scope.row.exceptionStatus == '5'"
                    >位置异常、回访异常</span
                  >
                  <span v-if="scope.row.exceptionStatus == '6'"
                    >时间异常、回访异常</span
                  >
                  <span v-if="scope.row.exceptionStatus == '7'"
                    >位置异常 时间异常 回访异常</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="orderNum"
                label="工单流水号"
                align="center"
                width="220"
                :show-overflow-tooltip="true"
                v-if="
                  this.tempTableChekbox.findIndex(
                    (item) => item == '工单流水号'
                  ) != -1
                "
              >
              </el-table-column>
              <el-table-column
                prop="servePersonName"
                label="服务人员"
                align="center"
                width="150"
                :show-overflow-tooltip="true"
                v-if="
                  this.tempTableChekbox.findIndex(
                    (item) => item == '服务人员'
                  ) != -1
                "
              >
              </el-table-column>
              <el-table-column
                prop="customerName"
                label="客户姓名"
                align="center"
                width="180"
                :show-overflow-tooltip="true"
                v-if="
                  this.tempTableChekbox.findIndex(
                    (item) => item == '客户姓名'
                  ) != -1
                "
              >
              </el-table-column>

              <el-table-column
                prop="customerPhone"
                label="联系方式"
                align="center"
                width="150"
                :show-overflow-tooltip="true"
                v-if="
                  this.tempTableChekbox.findIndex(
                    (item) => item == '联系方式'
                  ) != -1
                "
              >
              </el-table-column>
              <el-table-column
                prop="ensure"
                label="套餐类型"
                align="center"
                width="220"
                :show-overflow-tooltip="true"
                v-if="
                  this.tempTableChekbox.findIndex(
                    (item) => item == '套餐类型'
                  ) != -1
                "
              >
              </el-table-column>
              <el-table-column
                prop="serviceTypeName"
                label="服务种类"
                align="center"
                width="180"
                :show-overflow-tooltip="true"
                v-if="
                  this.tempTableChekbox.findIndex(
                    (item) => item == '服务种类'
                  ) != -1
                "
              >
              </el-table-column>

              <el-table-column
                prop="productName"
                label="服务项目"
                align="center"
                width="220"
                :show-overflow-tooltip="true"
                v-if="
                  this.tempTableChekbox.findIndex(
                    (item) => item == '服务项目'
                  ) != -1
                "
              >
              </el-table-column>

              <el-table-column
                prop="processStatus"
                label="状态"
                align="center"
                width="180"
                :show-overflow-tooltip="true"
                v-if="
                  this.tempTableChekbox.findIndex((item) => item == '状态') !=
                  -1
                "
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.handleStatus == '0'">未处置</span>
                  <span v-if="scope.row.handleStatus == '1'">已处置</span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 异常工单分页 -->
          <div class="bottom-page">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="query.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
          <!-- 异常工单分页 -->

          <div class="listBox-item" id="detailBox">
            <el-card>
              <el-row>
                <el-col style="width: 250px; margin-top: 14px">
                  <el-image
                    style="width: 100%; height: 300px"
                    :src="detail.picStart ? detail.picStart : ''"
                    fit="cover"
                  >
                    <div slot="error" class="image-slot">
                      <i
                        style="font-size: 250px"
                        class="el-icon-picture-outline"
                      ></i>
                    </div>
                  </el-image>
                </el-col>
                <el-col
                  style="
                    width: calc(100% - 250px);
                    padding-left: 30px;
                    box-sizing: border-box;
                  "
                >
                  <el-tabs v-model="detailActiveName" @tab-click="handleClick">
                    <el-tab-pane
                      class="detailInfo"
                      label="异常工单详情"
                      name="onefirst"
                    >
                      <el-form label-width="120px">
                        <div style="display: flex">
                          <div style="width: 50%">
                            <el-form-item label-width="120px" label="异常类型">
                              <!-- <el-select
                                                              disabled
                                                              v-model="
                                                                  detail.exceptionStatus
                                                              "
                                                              placeholder="请选择"
                                                              style="width: 100%"
                                                              size="medium"
                                                          >
                                                              <el-option
                                                                  value="1"
                                                                  label="位置异常"
                                                              ></el-option>
                                                              <el-option
                                                                  value="2"
                                                                  label="时间异常"
                                                              ></el-option>
                                                              <el-option
                                                                  value="4"
                                                                  label="回访异常"
                                                              ></el-option>
                                                          </el-select> -->
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.exceptionStatusValue"
                              ></el-input>
                            </el-form-item>
                            <el-form-item
                              label-width="120px"
                              label="套餐服务时长"
                            >
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.period"
                              ></el-input>
                            </el-form-item>
                            <el-form-item
                              label-width="120px"
                              label="实际服务时长"
                            >
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.realTime"
                              ></el-input>
                            </el-form-item>
                          </div>
                          <div style="width: 50%">
                            <el-form-item label-width="120px" label="开始距离">
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.startDistance"
                              ></el-input>
                            </el-form-item>
                            <el-form-item label-width="120px" label="结束距离">
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.endDistance"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </div>
                      </el-form>
                    </el-tab-pane>

                    <el-tab-pane
                      class="detailInfo"
                      label="客户信息"
                      name="first"
                    >
                      <el-form label-width="120px">
                        <div style="display: flex">
                          <div style="width: 50%">
                            <el-form-item label="客户姓名:">
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.customerName"
                              ></el-input>
                            </el-form-item>
                            <el-form-item label="联系人:">
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.customerName"
                              ></el-input>
                            </el-form-item>
                            <el-form-item label="联系方式一:">
                              <el-input
                                style="width: 95%"
                                disabled
                                v-model="detail.customerPhone"
                              ></el-input>
                              <!-- <el-col :span="1"> -->
                              <i
                                class="el-icon-phone"
                                style="cursor: pointer"
                                title="电话"
                                @click="callPhone(detail.customerPhone, '1')"
                              ></i>
                              <!-- </el-col> -->
                            </el-form-item>
                            <el-form-item
                              label="联系方式二:"
                              v-if="detail.otherTelephone == 1"
                            >
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.familyPhone"
                              ></el-input>
                            </el-form-item>
                            <!-- 增加字段 -->
                            <el-form-item label="家庭电话:">
                              <el-input
                                disabled
                                style="width: 95%"
                                v-model="detail.familyCall"
                              ></el-input>
                              <i
                                class="el-icon-phone"
                                style="cursor: pointer"
                                title="电话"
                                @click="callPhone(detail.familyCall, '3')"
                              ></i>
                            </el-form-item>
                            <el-form-item label="紧急联系人:">
                              <el-input
                                disabled
                                style="width: 95%"
                                v-model="detail.phone"
                              ></el-input>
                              <i
                                class="el-icon-phone"
                                style="cursor: pointer"
                                title="电话"
                                @click="callPhone(detail.phone, '4')"
                              ></i>
                            </el-form-item>
                          </div>
                          <div style="width: 50%">
                            <el-form-item
                              label="是否需要其他联系方式："
                              prop="customerType"
                              label-width="170px"
                            >
                              <el-select
                                disabled
                                style="width: 100%"
                                v-model="detail.otherTelephone"
                                @change="otherTelephone"
                                placeholder="请选择"
                                size="medium"
                              >
                                <el-option value="1" label="是"></el-option>
                                <el-option value="2" label="否"></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="用户类型：" prop="userType">
                              <el-select
                                disabled
                                style="width: 100%"
                                v-model="detail.userType"
                                multiple
                                placeholder="请选择"
                                size="medium"
                              >
                                <el-option
                                  v-for="(item, index) in userType"
                                  :key="index"
                                  :label="item.dictLabel"
                                  :value="item.dictCode"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                        </div>

                        <div style="width: 100%">
                          <el-form-item label="联系地址一:">
                            <el-input
                              disabled
                              style="width: 100%"
                              v-model="detail.address"
                            ></el-input>
                          </el-form-item>
                          <el-form-item
                            label="联系地址二:"
                            v-if="detail.otherTelephone == 1"
                          >
                            <el-input disabled style="width: 70%"></el-input>
                          </el-form-item>
                        </div>
                      </el-form>
                    </el-tab-pane>
                    <el-tab-pane
                      class="detailInfo"
                      label="工单详情"
                      name="second"
                    >
                      <el-form label-width="120px">
                        <div style="display: flex">
                          <div style="width: 50%">
                            <el-form-item label="套餐类型:">
                              <el-input
                                disabled
                                v-model="detail.ensure"
                              ></el-input>
                              <!-- <el-select
                                                              disabled
                                                              v-model="
                                                                  detail.ensure
                                                              "
                                                              placeholder="请选择"
                                                              style="width: 100%"
                                                              size="medium"
                                                          >
                                                              <el-option
                                                                  v-for="item in ensureList"
                                                                  :key="item.id"
                                                                  :label="
                                                                      item.mealType
                                                                  "
                                                                  :value="item.id"
                                                              >
                                                              </el-option>
                                                          </el-select> -->
                            </el-form-item>
                            <!-- 服务种类 -->
                            <el-form-item label="服务种类:">
                              <el-select
                                disabled
                                v-model="detail.serviceTypeName"
                                placeholder="请选择"
                                style="width: 100%"
                                size="medium"
                              >
                                <el-option
                                  v-for="item of serviceTypeList"
                                  :key="item.id"
                                  :label="item.serviceTypeName"
                                  :value="item.id"
                                >
                                </el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="计划时间:">
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.sertime"
                              >
                              </el-input>
                            </el-form-item>
                          </div>
                          <div style="width: 50%">
                            <el-form-item
                              label="工单类型："
                              prop="customerType"
                            >
                              <el-select
                                disabled
                                style="width: 100%"
                                v-model="detail.customerType"
                                placeholder="请选择"
                                size="medium"
                              >
                                <el-option
                                  label="老干服务工单"
                                  value="4"
                                ></el-option>
                                <el-option
                                  label="民政服务工单"
                                  value="6"
                                ></el-option>
                                <el-option
                                  label="文明办服务工单"
                                  value="10"
                                ></el-option>
                                <el-option
                                  label="残联服务工单"
                                  value="3"
                                ></el-option>
                                <el-option
                                  label="商业服务工单"
                                  value="7"
                                ></el-option>
                                <el-option
                                  label="退役军人服务工单"
                                  value="14"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="服务时长:">
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.period"
                              >
                              </el-input>
                            </el-form-item>
                            <el-form-item label="服务项目:">
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.productName"
                              >
                              </el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <el-form-item label="其他说明:">
                          <el-input
                            disabled
                            style="width: 70%"
                            v-model="detail.otherDesc"
                          >
                          </el-input>
                        </el-form-item>
                      </el-form>
                    </el-tab-pane>
                    <el-tab-pane
                      class="detailInfo"
                      label="服务人员"
                      name="third"
                    >
                      <el-form label-width="120px">
                        <div style="display: flex">
                          <div style="width: 50%">
                            <el-form-item label="机构:">
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.servestationName"
                              >
                              </el-input>
                            </el-form-item>
                            <el-form-item label="服务人员:">
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.servePersonName"
                              >
                              </el-input>
                            </el-form-item>
                            <el-form-item label="加盟商:">
                              <el-select
                                disabled
                                style="width: 100%"
                                v-model="detail.franchisee"
                                placeholder="请选择"
                                size="medium"
                              >
                                <el-option label="是" value="是"></el-option>
                                <el-option label="否" value="否"></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item
                              label="是否有从属服务人员:"
                              label-width="160px"
                            >
                              <el-select
                                disabled
                                style="width: 100%"
                                v-model="detail.otherServePerson"
                                placeholder="请选择"
                                size="medium"
                              >
                                <el-option label="是" value="是"></el-option>
                                <el-option label="否" value="否"></el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                          <div style="width: 50%">
                            <el-form-item label="服务时长:">
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.realTime"
                              >
                              </el-input>
                            </el-form-item>
                            <el-form-item label="服务项目:">
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.productName"
                              >
                              </el-input>
                            </el-form-item>

                            <el-form-item label="联系方式:">
                              <el-input
                                disabled
                                style="width: 95%"
                                v-model="detail.servePersonPhone"
                              >
                              </el-input>
                              <i
                                class="el-icon-phone"
                                style="cursor: pointer"
                                title="电话"
                                @click="callPhone(detail.servePersonPhone, '2')"
                              ></i>
                            </el-form-item>
                            <el-form-item label="是否有志愿者:">
                              <el-select
                                disabled
                                style="width: 100%"
                                v-model="detail.volunteer"
                                placeholder="请选择"
                                size="medium"
                              >
                                <el-option label="是" value="是"></el-option>
                                <el-option label="否" value="否"></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item
                              label="加盟商:"
                              v-if="detail.franchisee == '是'"
                            >
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.jiamengEstimate"
                              >
                              </el-input>
                            </el-form-item>
                            <el-form-item
                              label="服务人员:"
                              v-if="detail.otherServePerson == '是'"
                            >
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.otherservePersonName"
                              >
                              </el-input>
                            </el-form-item>
                            <el-form-item
                              label="志愿者:"
                              v-if="detail.volunteer == '是'"
                            >
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.otherReturnContent"
                              >
                              </el-input>
                            </el-form-item>
                          </div>
                        </div>
                      </el-form>
                    </el-tab-pane>
                    <el-tab-pane
                      class="detailInfo"
                      label="处理信息"
                      name="fourth"
                    >
                      <el-form :model="detail">
                        <el-form-item label="APP用户反馈语音评价：">
                          <el-input
                            disabled
                            v-model="detail.evaluate"
                            style="width: 70%"
                          ></el-input>
                        </el-form-item>
                        <audio
                          controls="controls"
                          preload="auto"
                          class="audioActive"
                          :src="detail.estimateRecord"
                        ></audio>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="开始时间：">
                              <el-date-picker
                                disabled
                                v-model="detail.timeStart"
                                type="datetime"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                style="width: 80%"
                              >
                              </el-date-picker>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="结束时间：">
                              <el-date-picker
                                disabled
                                v-model="detail.timeEnd"
                                type="datetime"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                style="width: 80%"
                              >
                              </el-date-picker>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-form-item label="服务内容：">
                          <el-input
                            disabled
                            type="textarea"
                            v-model="detail.visitContent"
                            style="width: 70%"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="与老人通话录音：">
                          <audio
                            controls="controls"
                            preload="auto"
                            class="audioActive"
                            :src="detail.fileNameOldMan"
                          ></audio>
                        </el-form-item>
                        <el-form-item label="与服务人员通话录音：">
                          <audio
                            controls="controls"
                            preload="auto"
                            class="audioActive"
                            :src="detail.fileNameServicePerson"
                          ></audio>
                        </el-form-item>
                      </el-form>
                    </el-tab-pane>
                    <el-tab-pane
                      class="detailInfo"
                      label="处理流程"
                      name="fifth"
                    >
                      <div class="block" style="padding: 2px">
                        <el-timeline>
                          <el-timeline-item
                            v-for="(item, index) in activities"
                            :key="index"
                            :color="index === 0 ? '#66b1ff' : ''"
                            :timestamp="item.createDate"
                            placement="top"
                          >
                            <el-card>
                              <p>
                                {{ item.statusDesc }}
                              </p>
                            </el-card>
                          </el-timeline-item>
                        </el-timeline>
                      </div>
                    </el-tab-pane>
                    <!-- 点击图片全屏展示 -->
                    <el-tab-pane label="服务图片" name="sixth">
                      <div
                        style="
                          display: flex;
                          justify-content: flex-start;
                          flex: 1;
                        "
                      >
                        <div style="width: 150px">服务开始结束图片：</div>
                        <div>
                          <el-image
                            style="
                              width: 150px;
                              height: 150px;
                              margin-right: 10px;
                            "
                            v-if="detail.picStart"
                            :src="detail.picStart"
                            :preview-src-list="[detail.picStart]"
                          ></el-image>
                          <el-image
                            style="
                              width: 150px;
                              height: 150px;
                              margin-right: 10px;
                            "
                            v-if="detail.picFinished"
                            :src="detail.picFinished"
                            :preview-src-list="[detail.picFinished]"
                          >
                          </el-image>
                        </div>
                      </div>
                      <div
                        style="
                          display: flex;
                          justify-content: flex-start;
                          flex-wrap: wrap;
                          margin-top: 10px;
                        "
                      >
                        <div style="width: 150px">服务中图片：</div>
                        <div
                          style="
                            display: flex;
                            justify-content: flex-start;
                            flex-wrap: wrap;
                            flex: 1;
                          "
                        >
                          <el-image
                            v-for="(item, index) in picRunning"
                            :key="index"
                            :src="item"
                            class="img"
                            style="
                              width: 150px;
                              height: 150px;
                              margin-right: 10px;
                              margin-bottom: 10px;
                            "
                            :preview-src-list="picRunning"
                          ></el-image>
                        </div>
                      </div>
                    </el-tab-pane>
                    <!-- 点击图片全屏展示 -->
                    <!-- 新增异常处理信息页面 -->
                    <el-tab-pane label="异常处理信息" name="seven">
                      <el-form label-width="120px">
                        <div style="display: flex">
                          <div style="width: 50%">
                            <el-form-item label="处理人:">
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.createName"
                              >
                              </el-input>
                            </el-form-item>

                            <el-form-item label="处理时间:">
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.createTime"
                              >
                              </el-input>
                            </el-form-item>

                            <el-form-item
                              label="处置状态:"
                              prop="processStatus"
                            >
                              <el-radio-group
                                v-model="detail.processStatus"
                                disabled
                              >
                                <el-radio label="1">完成</el-radio>
                                <el-radio label="2">回退</el-radio>
                                <el-radio label="3">改派</el-radio>
                                <el-radio label="4">作废</el-radio>
                              </el-radio-group>
                            </el-form-item>

                            <el-form-item label="处置内容:">
                              <el-input
                                disabled
                                style="width: 100%"
                                v-model="detail.processDesc"
                              >
                              </el-input>
                            </el-form-item>
                          </div>
                          <div style="width: 50%">
                            <el-col :span="8" :offset="2" class="imgBox">
                              <div
                                style="text-align: left; padding-bottom: 10px"
                              >
                                处理图片:
                              </div>
                              <el-image
                                style="width: 200px; height: 240px"
                                :src="detail.processPic"
                                :preview-src-list="[detail.processPic]"
                              ></el-image>
                            </el-col>
                          </div>
                        </div>
                      </el-form>
                    </el-tab-pane>
                    <!-- 新增异常处理信息页面 -->
                  </el-tabs>
                </el-col>
              </el-row>
            </el-card>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="工单异常类型" :visible.sync="dialogVisible" width="45%">
      <div>
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="addDialogVisibleS('新增')"
          >新增
        </el-button>
      </div>
      <div>
        <el-table
          :data="tableDatas"
          border
          style="width: 100%; margin-top: 5px"
          :header-cell-style="{
            background: '#f2f2f2',
            color: '#000',
          }"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="70"
          ></el-table-column>
          <el-table-column
            label="异常类型"
            align="center"
            prop="exceptionStatus"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.exceptionStatus == 1">位置异常</span>
              <span v-if="scope.row.exceptionStatus == 2">时间异常</span>
              <span v-if="scope.row.exceptionStatus == 4">回访异常</span>
            </template>
          </el-table-column>
          <el-table-column
            label="位置偏移范围"
            align="center"
            prop="positionRange"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.positionRange == 50">50米</span>
              <span v-if="scope.row.positionRange == 100">100米</span>
              <span v-if="scope.row.positionRange == 150">150米</span>
              <span v-if="scope.row.positionRange == 200">200米</span>
            </template>
          </el-table-column>
          <el-table-column
            label="不满足套餐时长"
            align="center"
            prop="notMealTime"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.notMealTime == 1">正常</span>
              <span v-if="scope.row.notMealTime == 2">异常</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" prop="status">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">启用</span>
              <span v-if="scope.row.status == 2">禁用</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="addDialogVisibleS('查看', scope.row)"
                >查看
              </el-button>
              <el-button
                type="text"
                @click="addDialogVisibleS('修改', scope.row)"
                >修改
              </el-button>
              <el-button type="text" @click="deleteItem(scope.row)"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="bottom-page">
        <el-pagination
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="query1.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total1"
        >
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :title="dialogTitle1"
      :visible.sync="addDialogVisible"
      width="40%"
      ref="addformRef"
      @close="dialogVisibleClone"
    >
      <el-form label-width="120px" :model="addFrom">
        <el-form-item label="异常类型:">
          <el-select v-model="addFrom.exceptionStatus" style="width: 43%">
            <el-option value="1" label="位置异常"></el-option>
            <el-option value="2" label="时间异常"></el-option>
            <el-option value="4" label="回访异常"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="位置偏移范围:" v-if="addFrom.exceptionStatus == 1">
          <el-select v-model="addFrom.positionRange" style="width: 43%">
            <el-option value="50" label="50米"></el-option>
            <el-option value="100" label="100米"></el-option>
            <el-option value="150" label="150米"></el-option>
            <el-option value="200" label="200米"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="不满足套餐时长:"
          v-if="addFrom.exceptionStatus == 2"
        >
          <el-select
            v-model="addFrom.notMealTime"
            disabled
            style="width: 260px"
          >
            <el-option value="1" label="正常"></el-option>
            <el-option value="2" label="异常"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属机构:">
          <el-cascader
            style="width: 260px"
            :key="isRescourceShow"
            :options="orgTree"
            v-model="addFrom.orgId"
            :show-all-levels="false"
            :props="{
              checkStrictly: true,
              emitPath: false,
              label: 'label',
              value: 'orgId',
            }"
            clearable
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="状态:">
          <el-radio-group v-model="addFrom.status">
            <el-radio label="1">启用</el-radio>
            <el-radio label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 处理工单弹出框 -->
    <el-dialog
      title="处置"
      :visible.sync="autDialogVisible"
      @close="closeDialog"
      width="60%"
    >
      <el-form
        :model="addFroms"
        :rules="rules"
        ref="addFroms"
        label-width="120px"
      >
        <el-form-item label="处置状态:" prop="processStatus">
          <el-radio-group v-model="addFroms.processStatus">
            <el-radio label="1" @click="accomplish">回访</el-radio>
            <el-radio label="4" @change="cancellation">作废</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 判断显示内容 -->
        <div v-if="addFroms.processStatus == 2">
          <el-form-item label="处置内容" prop="processDesc">
            <el-input v-model="addFroms.processDesc"></el-input>
          </el-form-item>
          <el-form-item label="上传图片">
            <el-upload
              class="avatar-uploader"
              :action="actionUrl"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="addFroms.processPic"
                :src="addFroms.processPic"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </div>
        <div v-if="addFroms.processStatus == 1">
          <el-form-item label="处置内容" prop="processDesc">
            <el-input v-model="addFroms.processDesc"></el-input>
          </el-form-item>
          <el-form-item label="上传图片">
            <el-upload
              class="avatar-uploader"
              :action="actionUrl"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="addFroms.processPic"
                :src="addFroms.processPic"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <!-- bug增加内容 -->
          <!-- 截取内容 -->
          <el-form-item label="是否通过App处理工单：" prop="fromApps">
            <el-radio-group v-model="addFroms.fromApps">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="上传图片是否符合规范：" prop="rightPic">
            <el-radio-group v-model="addFroms.rightPic">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="服务时间是否符合规范：" prop="rightTime">
            <el-radio-group v-model="addFroms.rightTime">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="拨打状态：" prop="dialStatus">
            <el-radio-group v-model="addFroms.dialStatus">
              <el-radio label="0">正常接听</el-radio>
              <el-radio label="1">无人接听</el-radio>
              <el-radio label="2">关机</el-radio>
              <el-radio label="3">停机</el-radio>
              <el-radio label="4">空号</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否上传语音评价：" prop="rightEstimateRecord">
            <el-radio-group v-model="addFroms.rightEstimateRecord">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="服务对象评价：" prop="estimate">
            <el-input type="textarea" v-model="addFroms.estimate"></el-input>
          </el-form-item>
          <el-form-item label="服务企业（组织）评价：" prop="jiamengEstimate">
            <el-input
              type="textarea"
              v-model="addFroms.jiamengEstimate"
            ></el-input>
          </el-form-item>
          <!-- 怎么绑定 -->
          <el-form-item label="客户满意度：" prop="estimateLevel">
            <el-select
              v-model="addFroms.estimateLevel"
              placeholder="请选择"
              @change="$forceUpdate()"
            >
              <el-option
                v-for="item in estimateLevelList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="是否上门：" prop="visited">
            <el-radio-group v-model="addFroms.visited">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item label="回访结果：" prop="visitResults">
            <el-radio-group v-model="addFroms.visitResults">
              <el-radio label="0">合格</el-radio>
              <el-radio label="1">不合格</el-radio>
              <el-radio label="2">作废</el-radio>
              <el-radio label="3">虚假工单</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <!-- <el-form-item label="理由：" prop="visitReason">
            <el-input type="textarea" v-model="addFroms.visitReason"></el-input>
          </el-form-item> -->
          <!-- 截取内容 -->
        </div>
        <!-- 显示状态id=3 -->
        <div v-if="addFroms.processStatus == 3">
          <div style="height: 12px; margin-top: 30px; color: #169bd5">
            服务人员
          </div>
          <el-divider></el-divider>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="机构：">
                <el-input
                  v-model="addFroms.servestationName"
                  @click.native="inputClickStation"
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="站点类型：" prop="statType">
                <el-select
                  style="width: 100%"
                  v-model="addFroms.statType"
                  placeholder="请选择"
                  size="medium"
                  :disabled="showTitle === '查看'"
                >
                  <el-option label="居家养老机构" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="服务人员：" prop="servePersonName">
                <el-input
                  v-model="addFroms.servePersonName"
                  size="medium"
                  :disabled="showTitle === '查看'"
                  @click.native="serveName1Fn"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式：" prop="servePersonPhone">
                <el-input
                  v-model="addFroms.servePersonPhone"
                  size="medium"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="是否有加盟商：" prop="franchisee">
                <el-radio-group v-model="jiameng">
                  <el-radio label="是"></el-radio>
                  <el-radio label="否"></el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="加盟商："
                prop="jiamengEstimate"
                v-if="jiameng == '是'"
              >
                <el-input
                  v-model="addFroms.jiamengEstimate"
                  size="medium"
                  :disabled="showTitle === '查看'"
                  @click.native="servestationNameFn"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                label="是否有从属服务人员："
                prop="otherServePerson"
              >
                <el-radio-group
                  :disabled="showTitle === '查看'"
                  v-model="otherServePerson"
                >
                  <!-- @change="isOtherServePerson" -->
                  <el-radio label="是"></el-radio>
                  <el-radio label="否"></el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="服务人员："
                prop="otherservePersonName"
                v-if="otherServePerson == '是'"
                @click.native="serveNameFn"
              >
                <el-input
                  v-model="addFroms.otherservePersonName"
                  size="medium"
                  :disabled="showTitle === '查看'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="是否有志愿者：" prop="volunteer">
                <el-radio-group
                  :disabled="showTitle === '查看'"
                  v-model="volunteer"
                >
                  <!-- @change="isVolunteer" -->
                  <el-radio label="是"></el-radio>
                  <el-radio label="否"></el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="志愿者："
                prop="otherReturnContent"
                v-if="volunteer == '是'"
              >
                <el-input
                  v-model="addFroms.otherReturnContent"
                  size="medium"
                  :disabled="showTitle === '查看'"
                  @click.native="voluteerNameFn"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 显示状态id=4 -->
        <div v-if="addFroms.processStatus == 4">
          <el-form-item label="处置内容" prop="processDesc">
            <el-input v-model="addFroms.processDesc"></el-input>
          </el-form-item>
          <el-form-item label="上传图片">
            <el-upload
              class="avatar-uploader"
              :action="actionUrl"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="addFroms.processPic"
                :src="addFroms.processPic"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <!-- 提交 -->
        <el-button type="primary" @click="submits">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 弹出框 -->
    <ServeStation
      ref="ServeStation"
      :first-type="addFroms"
      :show-station.sync="showStation"
      @send="sendServestation"
    ></ServeStation>
    <!-- 服务人员 -->
    <el-dialog
      title="服务人员"
      :visible.sync="showServeName1"
      width="40%"
      append-to-body
      :before-close="showServeName1Close"
      :close-on-click-modal="false"
    >
      <div class="cu-title1">
        <div class="cu-title2">
          <div>服务人员：</div>
          <el-input size="medium" v-model="serveName1"></el-input>
        </div>
        <div class="cu-title3">
          <el-button type="primary" size="medium" @click="getServeName1DataList"
            >查询
          </el-button>
        </div>
      </div>
      <div style="margin: 20px 0">
        <el-table
          class="form-table"
          :data="serveName1TableData"
          border
          highlight-current-row
          @current-change="getServePersonName"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            fixed
            type="index"
            label="序号"
            width="50"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="personName"
            label="名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="personPhone"
            label="手机号"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          @size-change="serveName1SizeChange"
          @current-change="serveName1CurrentChange"
          :page-sizes="[5, 10, 15, 20]"
          :current-page="query.pageNo"
          :page-size="query.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 15px;
        "
      >
        <el-button type="primary" @click="serveName1Send">保存</el-button>
        <el-button @click="showServeName1Close">取 消</el-button>
      </div>
    </el-dialog>
    <!--从属服务人员 -->
    <el-dialog
      title="从属服务人员"
      :visible.sync="showServeName"
      width="40%"
      append-to-body
      :before-close="showServeNameClose"
      :close-on-click-modal="false"
    >
      <div class="cu-title1">
        <div class="cu-title2">
          <div>服务人员：</div>
          <el-input size="medium" v-model="serveName"></el-input>
        </div>
        <div class="cu-title3">
          <el-button type="primary" size="medium" @click="getServeName1DataList"
            >查询
          </el-button>
        </div>
      </div>
      <div style="margin: 20px 0">
        <el-table
          class="form-table"
          :data="serveNameTableData"
          stripe
          tooltip-effect="dark"
          style="width: 100%"
          highlight-current-row
          @current-change="getServePersonName"
        >
          <el-table-column
            align="center"
            fixed
            type="index"
            label="序号"
            width="50"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="personName"
            label="名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="personPhone"
            label="手机号"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          @size-change="serveNameSizeChange"
          @current-change="serveNameCurrentChange"
          :page-sizes="[5, 10, 15, 20]"
          :current-page="query.pageNo"
          :page-size="query.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
      <div style="display: flex; align-items: center; justify-content: center">
        <el-button type="primary" @click="serveNameSend">保存</el-button>
        <el-button @click="showServeNameClose">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 志愿者 -->
    <el-dialog
      title="志愿者"
      :visible.sync="showVolunteer"
      width="40%"
      append-to-body
      :close-on-click-modal="false"
      :before-close="onVolunteerClose"
    >
      <div class="cu-title1">
        <div class="cu-title2">
          <div>志愿者：</div>
          <el-input size="medium" v-model="volunteerName"></el-input>
        </div>
        <div class="cu-title3">
          <el-button type="primary" size="medium" @click="getDataList"
            >查询
          </el-button>
        </div>
      </div>
      <div style="margin: 20px 0">
        <el-table
          class="form-table"
          :data="volunteerTableData"
          @selection-change="volunteerSelectionChange"
          ref="tb"
          stripe
          border
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            fixed
            type="index"
            label="序号"
            width="50"
          >
          </el-table-column>
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            label="姓名"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="mobile"
            label="手机号"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
      <div style="margin: 10px 0">
        <el-pagination
          :pager-count="5"
          @size-change="volunteerSizeChange"
          @current-change="volunteerCurrentChange"
          :page-sizes="[5, 10, 15, 20]"
          :current-page="query.pageNo"
          :page-size="query.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
      <div style="display: flex; justify-content: center; align-items: center">
        <el-button type="primary" @click="volunteerSend">保存</el-button>
        <el-button @click="onVolunteerClose">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 加盟商 -->
    <el-dialog
      title="加盟商"
      :visible.sync="showSallianceBusiness"
      width="40%"
      append-to-body
      :before-close="onJMSClose"
      :close-on-click-modal="false"
    >
      <div class="cu-title1">
        <div class="cu-title2">
          <div>加盟商</div>
          <el-input size="medium" v-model="franchiseeName"></el-input>
        </div>
        <div class="cu-title3">
          <el-button type="primary" size="medium" @click="getJMSList"
            >查询
          </el-button>
        </div>
      </div>
      <div style="margin: 20px 0">
        <el-table
          class="form-table"
          :data="jmTableData"
          border
          @current-change="getJMS"
          style="width: 100%"
        >
          <el-table-column
            fixed
            type="index"
            align="center"
            label="序号"
            width="60"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="franchiseeName"
            label="名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="address"
            label="地址"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          @size-change="jmSizeChange"
          @current-change="jmCurrentChange"
          :page-sizes="[5, 10, 15, 20]"
          :current-page="query.pageNo"
          :page-size="query.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 15px;
        "
      >
        <el-button type="primary" @click="jmSend">保存</el-button>
        <el-button @click="onJMSClose">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 回访 -->
    <!-- <el-dialog
            title="回访"
            :visible.sync="showHf"
            width="40%"
            append-to-body
            :close-on-click-modal="false"
        >
            <div
                style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                "
            >
                <el-button type="primary" @click="showHf == false"
                    >保存</el-button
                >
                <el-button @click="showHf == false">取 消</el-button>
            </div>
        </el-dialog> -->
  </div>
</template>

<script>
import AMap from "AMap" // 引入高德地图
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
import audioLink from "@/api/audio"
import ServeStation from "../component/serveStation.vue"
import exportVue from "@/utils/exportVue"
export default {
  components: {
    ServeStation,
  },
  data() {
    return {
      servicePgdId: "",
      jiameng: "",
      otherServePerson: "",
      volunteer: false,
      // 增加内容
      provinceList: [],
      cityList: [],
      areaList: [],
      streetList: [],
      communityList: [],
      estimateLevelList: [
        { value: "0", label: "未评价" },
        { value: "1", label: "没有服务" },
        { value: "2", label: "不满意" },
        { value: "3", label: "服务一般" },
        { value: "4", label: "满意" },
        { value: "5", label: "非常满意" },
      ],

      seeState: "success",
      seeShow: false,
      exceptionType: 2,
      map: null,
      markers: [], //地图标记点
      isSearchContent: true,
      queryForm: {
        customerType: this.$route.params.type,
      },
      tableData: [],
      volunteer: false,
      dialogVisible: false,
      addDialogVisible: false,
      autDialogVisible: false,
      showServeName: false,
      showServeName1: false,
      showVolunteer: false,
      showSallianceBusiness: false,
      jmTableData: [],
      franchiseeName: "",
      serveName1: "",
      serveName1TableData: [],
      volunteerName: "",
      // 弹窗修改信息
      addFroms: {
        estimateLevel: "0",
        visitReason: "",
        visitResults: "0",
        visited: "0",
        jiamengEstimate: "",
        estimate: "",
        // 无prop
        dialStatus: "0",
        fromApps: "0",
        rightPic: "0",
        rightTime: "0",
        processDesc: "",
        rightEstimateRecord: "0",
        processStatus: "1",
        servestationName: "",
        // jiameng: "",
        statType: "",
        servePersonName: "",
        servePersonPhone: "",
        franchisee: "",
        jiamengEstimate: "",
        // otherServePerson: "",
        // volunteer: false,
        otherReturnContent: "",
      },
      addFrom: {},
      dialogTitle1: "",
      qtlxfs: false,
      actionUrl: "",
      tempTableChekbox: [
        "序号",
        "操作",
        "工单流水号",
        "服务人员",
        "异常类型",
        "客户姓名",
        "联系方式",
        "套餐类型",
        "服务种类",
        "服务项目",
        "状态",
      ],
      tableChekbox: [
        "序号",
        "操作",
        "工单流水号",
        "服务人员",
        "异常类型",
        "客户姓名",
        "联系方式",
        "套餐类型",
        "服务种类",
        "服务项目",
        "状态",
      ],
      serviceTypeList: [],
      showStation: false,
      activities: [],
      query: {
        pageNo: 1,
        pageSize: 5,
      },
      isRescourceShow: 0,
      volunteerTemp: "",
      total: 0,
      query1: {
        pageNo: 1,
        pageSize: 5,
      },
      total1: 0,
      detail: {
        eventFile1: [],
        userTypes: [],
      },
      showTitle: {
        type: String,
        default: "",
      },
      totalCount: 0,
      serveName: "",
      volunteerTableData: [],
      serveNameTableData: [],
      detailActiveName: "first",
      tableDatas: [],
      rules: {
        processStatus: [
          {
            required: true,
            message: "请选择处置状态",
            trigger: "blur",
          },
        ],
        processDesc: [
          {
            required: true,
            message: "处置内容不能为空",
            trigger: "blur",
          },
        ],
      },
      // 机构树
      orgTree: [],
      // 套餐类型列表
      ensureList: [],
      userType: [],
      showHf: true,
      picRunning: [],
    }
  },
  watch: {
    orgTree() {
      ++this.isRescourceShow
      // console.log(this.isRescourceShow)
    },
    "$route.params.type"() {
      this.$router.go(0)
    },
  },
  created() {
    this.actionUrl =
      baseURL + "/jgyl/controller/uploadController/info/uploadPhoto"
    this.showList()
    this.getDataList()
    this.getProvince()
  },
  async mounted() {
    await this.loadMap()
  },
  inject: ["reload"], //注入
  methods: {
    //点击完成时初始化数据
    accomplish() {
      this.addFroms = {
        estimateLevel: "0",
        visitReason: "",
        visitResults: "0",
        visited: "0",
        jiamengEstimate: "",
        estimate: "",
        // 无prop
        dialStatus: "0",
        fromApps: "0",
        rightPic: "0",
        rightTime: "0",
        processDesc: "",
        rightEstimateRecord: "0",
        processStatus: "1",
        servestationName: "",
        statType: "",
        servePersonName: "",
        servePersonPhone: "",
        franchisee: "",
        // jiameng: "",
        jiamengEstimate: "",
        // otherServePerson: "",
        // volunteer: false,
        otherReturnContent: "",
      }
      this.jiameng = ""
      this.otherServePerson = ""
      this.volunteer = false
    },
    rollback() {
      this.jiameng = ""
      this.otherServePerson = ""
      this.volunteer = false
      this.addFroms = {
        estimateLevel: "0",
        visitReason: "",
        visitResults: "0",
        visited: "0",
        jiamengEstimate: "",
        estimate: "",
        // jiameng: "",
        // 无prop
        dialStatus: "0",
        fromApps: "0",
        rightPic: "0",
        rightTime: "0",
        processDesc: "",
        rightEstimateRecord: "0",
        processStatus: "2",
        servestationName: "",
        statType: "",
        servePersonName: "",
        servePersonPhone: "",
        franchisee: "",
        jiamengEstimate: "",
        // otherServePerson: "",
        // volunteer: false,
        otherReturnContent: "",
      }
    },
    reassignment() {
      this.jiameng = ""
      this.otherServePerson = ""
      this.volunteer = false
      this.addFroms = {
        estimateLevel: "0",
        visitReason: "",
        visitResults: "0",
        visited: "0",
        // jiameng: "",
        jiamengEstimate: "",
        estimate: "",
        // 无prop
        dialStatus: "0",
        fromApps: "0",
        rightPic: "0",
        rightTime: "0",
        processDesc: "",
        rightEstimateRecord: "0",
        processStatus: "3",
        servestationName: "",
        statType: "",
        servePersonName: "",
        servePersonPhone: "",
        franchisee: "",
        jiamengEstimate: "",
        // otherServePerson: "",
        // volunteer: false,
        otherReturnContent: "",
      }
    },
    cancellation() {
      this.jiameng = ""
      this.otherServePerson = ""
      this.volunteer = false
      this.addFroms = {
        estimateLevel: "0",
        visitReason: "",
        visitResults: "0",
        visited: "0",
        jiamengEstimate: "",
        estimate: "",
        // jiameng: "",
        // 无prop
        dialStatus: "0",
        fromApps: "0",
        rightPic: "0",
        rightTime: "0",
        processDesc: "",
        rightEstimateRecord: "0",
        processStatus: "4",
        servestationName: "",
        statType: "",
        servePersonName: "",
        servePersonPhone: "",
        franchisee: "",
        jiamengEstimate: "",
        // otherServePerson: "",
        // volunteer: false,
        otherReturnContent: "",
      }
    },
    //获取省级
    async getProvince() {
      this.provinceList = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistricts()
      this.provinceList = province.districtList
    },
    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.queryForm.cityid = ""
      this.queryForm.zoneid = ""
      this.queryForm.streetid = ""
      this.queryForm.shequid = ""
      let city = await this.getStreetList(val)
      // console.log(val, this.queryForm.provinceId)
      // this.queryForm.servicePgdAddress = this.queryForm.provinceId
      this.queryForm.provinceId = val

      this.cityList = city
      // console.log(this.cityList)
    },
    //市级地址发生改变
    async handleCity(val) {
      // console.log(val, "qu")
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.queryForm.zoneid = ""
      this.queryForm.streetid = ""
      this.queryForm.shequid = ""
      let area = await this.getStreetList(val)
      // console.log(1111, this.queryForm.cityid)
      // this.queryForm.servicePgdAddress =
      //   this.queryForm.provinceId + "-" + this.queryForm.cityid
      this.areaList = area
      this.queryForm.cityid = val

      // console.log(this.areaList)
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.queryForm.streetid = ""
      this.queryForm.shequid = ""
      // val = val.replace(/.$/, "");
      // this.queryForm.servicePgdAddress =
      //   this.queryForm.provinceId +
      //   "-" +
      //   this.queryForm.cityid +
      //   "-" +
      //   this.queryForm.zoneid
      // console.log(this.queryForm.servicePgdAddress)
      let street = await this.getStreetList(val)
      // console.log(this.queryForm)
      // console.log(1111, this.queryForm.zoneid, val)
      this.streetList = street
      this.queryForm.zoneid = val
      this.$forceUpdate()
    },
    //街道地址列表
    getStreetList(val) {
      // console.log(val)
      if (val != "null") {
        let self = this
        return new Promise((resolve, reject) => {
          self.$http
            .request({
              url: "/ypt/admin/addressYpe/info/findList",
              method: "POST",
              data: {
                parentId: val,
                pageNo: 1,
                pageSize: -1,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                if (!res.content) {
                  resolve([])
                  return
                }
                // this.streetList = res.content.list
                resolve(res.content.list)
              } else {
                resolve([])
              }
            })
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    // 社区地址列表
    getCommityList(val) {
      // console.log(val)
      if (val != "null") {
        let self = this
        return new Promise((resolve, reject) => {
          self.$http
            .request({
              url: "/ypt/admin/standardAddress/info/StandardAddressTree",
              method: "POST",
              data: {
                jiedaoId: val,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                if (!res.content) {
                  resolve([])
                  return
                }
                resolve(res.content)
              } else {
                resolve([])
              }
            })
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    //街道地址发生变化
    async streetChange(val) {
      // console.log(val)
      this.queryForm.shequid = ""
      let communityList = await this.getStreetList(val)
      this.communityList = communityList
      this.queryForm.streetid = val
      // console.log(1111, this.queryForm.streetid)
      // this.queryForm.servicePgdAddress =
      //   this.queryForm.provinceId +
      //   "-" +
      //   this.queryForm.cityid +
      //   "-" +
      //   this.queryForm.zoneid +
      //   "-" +
      //   this.queryForm.streetid

      // console.log(this.queryForm.servicePgdAddress)
      // console.log(this.communityList)
      this.$forceUpdate()
    },
    // 社区
    handleCommunityChange(val) {
      // console.log(val)
      this.queryForm.shequid = val
      // this.queryForm.servicePgdAddress =
      //   this.queryForm.provinceId +
      //   "-" +
      //   this.queryForm.cityid +
      //   "-" +
      //   this.queryForm.zoneid +
      //   "-" +
      //   this.queryForm.streetid +
      //   "-" +
      //   val
      // console.log(1111, this.queryForm.communityName)
      // console.log(this.queryForm.communityId)
      // console.log(this.queryForm.servicePgdAddress)
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {}

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {})
    },

    callPhone(phone, type) {
      if (phone == null || phone == "") {
        this.$message.warning("号码无效，暂无法拨号")
      } else {
        this.$store.dispatch("setPhone", phone)
        exportVue.$emit("question", true)
        setTimeout(() => {
          this.callType(phone, type)
        }, 5000)
      }
    },
    //获取用户类型
    // getusertypeList() {
    //   let query = {
    //     pageNum: 1,
    //     pageSize: 999,
    //     dictType: "usertype",
    //   }
    //   this.$http
    //     .request({
    //       url: "/rbac/system/dict/data/list",
    //       method: "get",
    //       params: query,
    //     })
    //     .then((res) => {
    //       if (res.code == 200) {
    //         if (res.rows != null) {
    //           this.userType = res.rows
    //         }
    //       }
    //     })
    // },

    // 拨号处理
    callType(phone, type) {
      const self = this
      request({
        url: "/jjyl/traffic/callInfo/info/saveCallIdforPdg",
        method: "POST",
        data: {
          remoteNum: phone,
          agentID: self.$store.state.seatNo,
          servicepgdId: self.detail.id,
          callToType: type,
        },
      }).then((res) => {})
    },

    handleClick(val) {
      // console.log(val.name, "参数")
      if (val.name == "fifth") {
        this.getStep()
      }
    },
    getStep() {
      request({
        url: "/jjyl/servicePgdProcessRecord/info/findList ",
        method: "POST",
        data: {
          orderNum: this.detail.orderNum,
          pageNo: 1,
          pageSize: 1000,
          // dataId:this.dataId
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            // console.log(res.content, "信息")
            // this.options = res.content
            this.activities = res.content
          } else {
            this.activities = []
          }
        }
      })
    },
    // 显示机构弹框
    inputClickStation() {
      if (this.showTitle === "查看") return
      this.showStation = true
      this.$nextTick(() => {
        // console.log(this.$refs.ServeStation)
        this.$refs.ServeStation && this.$refs.ServeStation.getDataList()
      })
    },
    // 机构弹框内点击保存
    sendServestation(data) {
      this.$set(this.addFroms, "serviceStationId", data.id)
      this.$set(this.addFroms, "servestationName", data.statName)
      this.getMeng()
      this.getJMSList()
      this.$set(this.addFroms, "franchisee", data.statName)
    },
    getDataList() {
      request({
        url: "/jjyl/admin/type/info/findList",
        method: "POST",
        data: {
          belongAddressLevel: 2,
          pageNo: 1,
          pageSize: 1000,
          // dataId:this.dataId
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.options = res.content
          } else {
            this.options = []
          }
        }
      })
    },
    // 从属服务人员
    serveNameFn() {
      if (this.showTitle === "查看") return
      if (!this.addFroms.serviceStationId) {
        this.$message.error("请先选择机构")
        return
      }
      this.showServeName = true
      this.getServeNameDataList()
    },
    // 显示服务人员弹框
    serveName1Fn() {
      if (this.showTitle === "查看") return
      if (!this.addFroms.serviceStationId) {
        this.$message.error("请先选择机构")
        return
      }
      this.showServeName1 = true
      this.getServeName1DataList()
    },
    // 服务人员页码切换
    serveName1SizeChange(val) {
      this.query.pageSize = val
      this.getServeName1DataList()
    },
    serveName1CurrentChange(val) {
      this.query.pageNo = val
      this.getServeName1DataList()
    },
    // 从属服务人员表格分页
    serveNameSizeChange(val) {
      this.query.pageSize = val
      this.getServeNameDataList()
    },
    serveNameCurrentChange(val) {
      this.query.pageNo = val
      this.getServeNameDataList()
    },
    //服务人员的表格获取
    getServeName1DataList() {
      request({
        url: "/jjyl/admin/serviceStaffCustomerCenter/info/findList",
        method: "POST",
        data: {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          // 获取当前机构下面的服务人员
          serviceStationName: this.addFroms.servestationName,
          servePersonName: this.serveName1,
          serveStation: this.addFroms.serviceStationId,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.serveName1TableData = res.content.elderList.list || []
          this.totalCount = res.content.elderList.count || 0
        } else {
          this.serveName1TableData = []
          this.totalCount = 0
          this.$message.error("该机构下暂无服务人员")
        }
      })
    },
    // 从属服务人员的表格获取
    getServeNameDataList() {
      request({
        url: "/jjyl/admin/serviceStaffCustomerCenter/info/findList",
        method: "POST",
        data: {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          // 获取当前机构下面的服务人员
          serviceStationName: this.addFroms.servestationName,
          servePersonName: this.serveName,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.serveNameTableData = res.content.elderList.list || []
          this.totalCount = res.content.elderList.count || 0
        } else {
          this.serveNameTableData = []
          this.totalCount = 0
          this.$message.error("获取服务人员失败")
        }
      })
    },
    // isOtherServePerson(val) {
    //   console.log(val)
    //   this.otherServePerson = val === "是"
    // },
    // isVolunteer(val) {
    //   console.log(val)

    //   this.volunteer = val === "是"
    // },
    // 服务人员点击保存
    serveName1Send() {
      this.$set(
        this.addFroms,
        "servePersonName",
        this.servePersonData.personName
      )
      this.$set(
        this.addFroms,
        "servePersonPhone",
        this.servePersonData.personPhone
      )
      this.$set(this.addFroms, "servePersonID", this.servePersonData.id)
      this.showServeName1Close()
    },
    // 从属服务人员点击保存
    serveNameSend() {
      this.$set(
        this.addFroms,
        "otherservePersonName",
        this.servePersonData.personName
      )
      // this.$set(this.serverObj, 'servePersonPhone', this.servePersonData.mobilePhone)
      this.$set(this.addFroms, "otherservePersonID", this.servePersonData.id)
      this.showServeNameClose()
    },
    // 服务人员弹框关闭
    showServeName1Close() {
      this.showServeName1 = false
      this.serveName1 = ""
      this.serveName1TableData = []
      this.query = {
        pageNo: 1,
        pageSize: 5,
      }
      this.totalCount = 0
    },
    // 从属服务人员弹框关闭
    showServeNameClose() {
      this.showServeName = false
      this.serveName = ""
      this.serveNameTableData = []
      this.query = {
        pageNo: 1,
        pageSize: 5,
      }
      this.totalCount = 0
    },
    // 服务人员选择人员
    getServePersonName(val) {
      this.servePersonData = val
    },
    //志愿者
    volunteerSelectionChange(data) {
      this.volunteerTemp = []
      if (data.length > 1) {
        this.$refs.tb.clearSelection()
        this.$refs.tb.toggleRowSelection(data.pop())
        this.volunteerTemp[0] = data.pop()
      } else {
        this.volunteerTemp = data
      }
    },
    // 志愿者
    voluteerNameFn() {
      if (this.showTitle === "查看") return
      this.showVolunteer = true
      this.getVoluteerList()
    },
    // 获取志愿者
    getVoluteerList() {
      request({
        url: "/jjyl/admin/volunteerArchive/info/list",
        method: "POST",
        data: {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          gridId: this.$store.state.info.gridId,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.volunteerTableData = res.content.list || []
          this.totalCount = res.content.count || 0
        } else {
          this.$message.error("获取志愿者失败")
        }
      })
    },

    //志愿者表格分页
    volunteerSizeChange(val) {
      this.query.pageSize = val
      this.getVoluteerList()
    },
    volunteerCurrentChange(val) {
      this.query.pageNo = val
      this.getVoluteerList()
    },
    volunteerSend() {
      if (this.volunteerTemp.length > 1) {
        this.$message.error("只能选择一个志愿者")
        return
      }
      this.showVolunteer = false
      if (this.volunteerTemp.length === 1) {
        // this.$set(this.serverObj, 'voluteerName', this.volunteerTemp[0].userName)
        // 代替志愿者字段
        this.$set(
          this.addFroms,
          "otherReturnContent",
          this.volunteerTemp[0].userName
        )
      }
    },
    onVolunteerClose() {
      // 志愿者弹框关闭
      this.showVolunteer = false
      this.query = {
        pageNo: 1,
        pageSize: 5,
      }
      this.totalCount = 0
      this.volunteerTemp = []
    },
    addOpen() {
      this.dialogVisible = true
      this.showList1()
    },
    addDialogVisibleS(title, row) {
      // console.log(title, row)
      this.getOrgTree()
      this.addDialogVisible = true
      this.dialogTitle1 = title
      if (title != "新增") {
        this.addFrom.exceptionStatus = row.exceptionStatus
        this.addFrom.positionRange = row.positionRange
        this.addFrom.positionRange = row.positionRange
        this.addFrom.notMealTime = row.notMealTime
        this.addFrom.status = row.status
        this.addFrom.orgId = row.orgId.toString()
        // console.log(this.addFrom.orgId, typeof this.addFrom.orgId)
        this.addFrom.orgName = row.orgName
        this.addFrom.id = row.id
        // console.log(this.addFrom)
      } else {
        this.addFrom = {
          exceptionStatus: "",
          positionRange: "",
          notMealTime: "2",
          status: "",
          orgId: "",
          orgName: "",
        }
      }
    },
    //是否存在加盟商
    getMeng() {
      // console.log(this.addFroms.servestationName)
      request({
        url: "/ypt/admin/franchisee/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 1000,
          // dataId:this.dataId
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            res.content.list.forEach((item) => {
              if (item.statName == this.addFroms.servestationName) {
                this.addFroms.franchisee = "是"
                // console.log(this.addFroms.franchisee)
                this.franchisee = true
                this.$forceUpdate()
              } else {
                this.addFroms.franchisee = "否"
                this.franchisee = true
                this.$forceUpdate()
              }
            })
          } else {
          }
        }
      })
    },
    // 保存选中的加盟商
    getJMS(val) {
      // console.log(val)
      if (val) {
        this.jiamengTemp = val
      }
    },
    //加盟商表格分页
    jmSizeChange(val) {
      this.query.pageSize = val
      this.getJMSList()
    },
    // 加盟商列表页数改变
    jmCurrentChange(val) {
      this.query.pageNo = val
    },
    // 加盟商弹框点击保存
    jmSend() {
      if (!this.jiamengTemp) {
        this.$message.error("请选择一个加盟商")
        return
      }
      this.showSallianceBusiness = false
      // this.$set(this.serverObj, "servestationNameJMS", this.jiamengTemp.franchiseeName)
      this.$set(
        this.addFroms,
        "jiamengEstimate",
        this.jiamengTemp.franchiseeName
      )
      this.$set(this.addFroms, "jiamengId", this.jiamengTemp.id)
    },
    // 获取加盟商列表
    getJMSList() {
      request({
        url: "/jjyl/admin/franchisee/info/findList",
        method: "POST",
        data: {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          serveStation: this.addFroms.serviceStationId,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.jmTableData = res.content.list || []
          this.totalCount = res.content.count || 0
          this.$set(
            this.addFroms,
            "franchisee",
            this.totalCount > 0 ? "是" : "否"
          )
        } else {
          this.$message.info("当前机构下暂无加盟商")
        }
      })
    },
    // 显示加盟商选择弹框
    servestationNameFn() {
      if (this.showTitle === "查看") return
      this.showSallianceBusiness = true
    },
    // 关闭加盟商弹框
    onJMSClose() {
      this.showSallianceBusiness = false
      this.franchiseeName = ""
      this.tempJiameng = ""
      this.query = {
        pageNo: 1,
        pageSize: 5,
      }
      this.totalCount = 0
    },
    // 删除
    async deleteItem(row) {
      const confirm = await this.$confirm(
        "此操作将永久删除该信息, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err)
      // console.log(confirm)
      if (confirm === "confirm") {
        request({
          url: "/jjyl/pgdExceptionType/info/deleteById",
          method: "POST",
          data: {
            id: row.id,
          },
        }).then((res) => {
          if (res.code == 200) {
            this.showList1()
            this.$message({
              message: "删除成功",
              type: "success",
            })
            return
          }
          this.$message({
            message: "删除失败",
            type: "error",
          })
        })
      } else {
        this.$message({
          message: "取消删除",
          type: "info",
        })
      }
    },
    closeDialog() {
      this.$refs.addFroms.resetFields()
      this.autDialogVisible = false
    },
    //  异常工单处置提交
    submit() {
      // console.log(this.addFrom.orgId)
      // if (Array.isArray(this.addFrom.orgId) && this.addFrom.orgId.length > 0) {
      //   this.addFrom.orgId = this.addFrom.orgId.pop()
      // } else {
      //   this.addFrom.orgId = null
      // }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      this.$http
        .request({
          url: "/jjyl/pgdExceptionType/info/save",
          method: "POST",
          data: {
            ...this.addFrom,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            this.addDialogVisible = false
            this.showList1()
            loading.close()
          } else {
            loading.close()
          }
        })
        .catch((error) => {
          this.addDialogVisible = false
          loading.close()
        })
    },
    // 显示弹出框
    addOpens(row) {
      // console.log(row)
      this.servicePgdId = row.servicePgdId
      this.autDialogVisible = true
      this.addFroms = {
        processStatus: "1",
        dialStatus: "0",
        fromApps: "0",
        rightPic: "0",
        rightTime: "0",
        visited: "0",
        rightEstimateRecord: "0",
      }

      this.orderid = row.id
    },
    // 提交修改信息
    submits() {
      // 提交前定义
      if (this.addFroms.processStatus == 4) {
        this.addFroms.visitResults = "2"
      } else if (this.addFroms.processStatus == 1) {
        this.addFroms.visitResults = "0"
      } else {
        this.addFroms.visitResults = "1"
      }
      if (
        this.addFroms.processStatus == 2 ||
        this.addFroms.processStatus == 3 ||
        this.addFroms.processStatus == 4
      ) {
        this.addFroms.estimateLevel = ""
        this.addFroms.visitResults = ""
        this.addFroms.visited = ""
        this.addFroms.dialStatus = ""
        this.addFroms.fromApps = ""
        this.addFroms.rightPic = ""
        this.addFroms.rightTime = ""
        this.addFroms.rightEstimateRecord = ""
      }
      console.log(this.addFroms)
      if (this.addFroms.processStatus == 4) {
        this.addFroms.closeReason = this.addFroms.processDesc
        delete this.addFroms.processDesc
        this.addFroms.askCloseName = this.$store.state.info.name
      }
      delete this.addFroms.franchisee
      console.log(this.addFroms)
      this.$http
        .request({
          url: "/jjyl/servicePgd/info/toProcess",
          method: "POST",
          data: {
            ...this.addFroms,
            // id: this.orderid,
            id: this.servicePgdId,
            states: "3",
            // callSeatName:this.$store.state.info.name,
          },
        })
        .then((res) => {
          // console.log(res)
          if (res.code == 200) {
            this.showList()
            this.closeDialog()
            this.$message.success("提交成功")
          } else {
            this.$message.error("提交失败")
            this.closeDialog()
            loading.close()
          }
        })
        .catch((error) => {
          this.closeDialog()
          loading.close()
        })
    },
    //查询所有工单翻页
    showList(e) {
      // console.log(this.queryForm)

      let params = {
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        states: 7,
        sort: "ascend",
        prop: "timeEnd",
        provinceId: this.queryForm.provinceId,
        cityid: this.queryForm.cityid,
        zoneid: this.queryForm.zoneid,
        streetid: this.queryForm.streetid,
        shequid: this.queryForm.shequid,
        customerName: this.queryForm.customerName,
        customerType: this.queryForm.customerType,
        customerphone: this.queryForm.customerphone,
        idCard: this.queryForm.idCard,
        timeEnd: this.queryForm.timeEnd,
        timeStart: this.queryForm.timeStart,
        address: this.queryForm.shequid,
        orderNum: this.queryForm.orderNum,
        servePersonName: this.queryForm.servePersonName,
        servePersonPhone: this.queryForm.servePersonPhone,
      }
      if (e == 1) {
        params.handleStatus = 1
      } else {
        params.handleStatus = 0
      }
      // console.log(params)
      this.$http
        .request({
          url: "/jjyl/servicePgd/info/findServicepgd",
          method: "POST",
          data: params,
        })
        .then((res) => {
          // console.log(res)
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.tableData = []
              this.total = 0
              return
            }
            this.tableData = res.content.list
            this.total = res.content.count
          }
        })
    },
    // 查看所有异常工单
    whole() {
      this.query.pageNo = 1
      this.seeShow = !this.seeShow
      if (this.seeShow == true) {
        this.seeState = "primary"
        this.showList(1)
      } else {
        this.seeState = "success"
        this.showList(0)
      }
      this.exceptionType = 2
    },
    // 选择表格选项
    tableChange(data) {
      if (data.exceptionStatus == "1") {
        data.exceptionStatusValue = "位置异常"
      }
      if (data.exceptionStatus == "2") {
        data.exceptionStatusValue = "时间异常"
      }
      if (data.exceptionStatus == "3") {
        data.exceptionStatusValue = "位置异常、时间异常"
      }
      if (data.exceptionStatus == "4") {
        data.exceptionStatusValue = "回访异常"
      }
      if (data.exceptionStatus == "5") {
        data.exceptionStatusValue = "位置异常、回访异常"
      }
      if (data.exceptionStatus == "6") {
        data.exceptionStatusValue = "时间异常、回访异常"
      }
      if (data.exceptionStatus == "7") {
        data.exceptionStatusValue = "位置异常 时间异常 回访异常"
      }
      // console.log(data)
      this.detail = data
      if (data.picRunning) {
        this.picRunning = data.picRunning.split(",")
      }
      // 查询紧急联系人
      this.$http
        .request({
          url: "jjyl/admin/all/customerContact/info/findList",
          method: "POST",
          data: {
            customerId: data.customer,
            contactType: 1,
            pageNo: 1,
            pageSize: 10,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            this.detail.phone = res.content[0].phone
            // console.log(res.content.phone)
          }
        })

      // 查询紧急联系人
      // this.$http
      //   .request({
      //     url: "/jjyl/admin/meal/info/findById",
      //     method: "POST",
      //     data: {
      //       id: data.ensure,
      //     },
      //   })
      //   .then((res) => {
      //     if (res.code == 200) {
      //       this.detail.ensureName = res.content.mealType
      //     }
      //   })
      // console.log(this.detail, "this.detail")
      if (data.userType != null) {
        this.detail.userTypes = data.userType.split(",")
        for (let i in this.detail.userTypes) {
          this.detail.userTypes[i] = Number(this.detail.userTypes[i])
        }
      }
      this.detail.fileNameOldMan = audioLink + "/" + data.fileNameOldMan
      this.detail.fileNameServicePerson =
        audioLink + "/" + data.fileNameServicePerson
      this.activities = []
      // this.getEnsureList()
      // this.getServiceTypeList()
      // 处理是否需要其他联系方式
      if (this.detail.familyPhone) {
        this.detail.otherTelephone = "1"
        this.qtlxfs = true
      } else {
        this.detail.otherTelephone = "2"
        this.qtlxfs = false
      }
      if (this.detailActiveName == "fifth") {
        this.getStep()
      }

      if (data.startlng) {
        this.map.remove(this.markers)
        this.markers = []
        // if (
        //   data.longitude == null || //老人第一次开始工单打的点 没有时
        //   data.latitude == ""
        // ) {
        //   data.longitude = data.longitudeElderly
        //   data.latitude = data.latitudeElderly
        // } else {
        //   data.longitude = data.longitude //有即用老人第一次开始工单打的点
        //   data.latitude = data.latitude
        // }
        let city = [
          {
            x: data.oldMenLongitude,
            y: data.oldMenLatitude,
            name: "老人位置",
            icon: require("../assets/img/icon3.png"),
          },
          {
            x: data.startlng,
            y: data.startlat,
            name: "服务开始位置",
            icon: require("../assets/img/icon2.png"),
          },
          {
            x: data.endlng,
            y: data.endlat,
            name: "服务结束位置",
            icon: require("../assets/img/icon1.png"),
          },
        ]
        city.forEach((e, i) => {
          if (e.x != null && e.y != null) {
            if (e.name == "服务开始位置") {
              console.log("开始位置")
              this.markers.push(
                new AMap.Marker({
                  position: [e.x, e.y],
                  icon: new AMap.Icon({
                    image: e.icon,
                    size: new AMap.Size(52, 52), //图标大小
                    imageSize: new AMap.Size(26, 26),
                  }),
                  label: {
                    offset: new AMap.Pixel(-75, 20),
                    content: e.name,
                  },
                })
              )
            } else if (e.name == "老人位置") {
              console.log("老人位置")
              this.markers.push(
                new AMap.Marker({
                  position: [e.x, e.y],
                  icon: new AMap.Icon({
                    image: e.icon,
                    size: new AMap.Size(52, 52), //图标大小
                    imageSize: new AMap.Size(26, 26),
                  }),
                  label: {
                    offset: new AMap.Pixel(-15, -22),
                    content: e.name,
                  },
                })
              )
            } else if (e.name == "服务结束位置") {
              console.log("jieshu")
              this.markers.push(
                new AMap.Marker({
                  position: [e.x, e.y],
                  icon: new AMap.Icon({
                    image: e.icon,
                    size: new AMap.Size(52, 52), //图标大小
                    imageSize: new AMap.Size(26, 26),
                  }),
                  label: {
                    offset: new AMap.Pixel(20, 20),
                    content: e.name,
                  },
                })
              )
            }
          }
        })
        this.map.add(this.markers)
        this.map.setFitView()
        this.$previewRefresh()
      }
    },
    // 获取套餐类型列表
    getEnsureList() {
      request({
        url: "/jjyl/admin/meal/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 9999,
          states: "1",
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          const arr = res.content.list || []
          arr.forEach((item) => {
            item.id = item.id + ""
          })
          this.ensureList = arr.filter((item) => {
            return item.states == "1"
          })
        }
      })
    },
    // 获取服务种类
    getServiceTypeList() {
      request({
        url: "/jjyl/admin/type/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 999,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          const arr = res.content.list || []
          // 过滤开启状态的服务种类
          this.serviceTypeList = arr.filter((item) => {
            return item.status == 1
          })
        } else {
          this.$message.error("获取服务种类失败")
        }
      })
    },
    otherTelephone(val) {
      this.qtlxfs = val == "1"
    },
    handleSelectionChange(val) {},
    //table列checkbox发生变化
    tableChekboxChange(val) {
      this.tempTableChekbox = val.map((item) => item)
    },
    //关闭弹框清除校验
    dialogVisibleClone() {
      // this.$refs.addformRef.resetFields(); //清除校验
      this.addDialogVisible = false //关闭弹框
    },
    // 查询
    QuerySearch() {
      if (this.seeShow == true) {
        this.exceptionType = 2
      } else {
        this.exceptionType = 1
      }
      this.showList()
    },
    showList1() {
      let params = {
        pageNo: this.query1.pageNo,
        pageSize: this.query1.pageSize,
      }
      this.$http
        .request({
          url: "/jjyl/pgdExceptionType/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.tableDatas = []
              this.total1 = 0
              return
            }
            this.tableDatas = res.content.list
            this.total1 = res.content.count
          }
        })
    },
    loadMap() {
      return new Promise((resolve, reject) => {
        this.map = new AMap.Map("map", {
          mapStyle: "amap://styles/fresh",
          resizeEnable: true,
          zoom: 9,
        })
        resolve()
      })
    },
    // 获取机构树
    async getOrgTree() {
      // const { content } = await post(
      //     "/rbac/admin/org/info/OrgTreeForOrgIdlist",
      //     {
      //         isValid: 1,
      //     }
      // )
      // this.orgTree = content;
      this.$post("/rbac/admin/org/info/OrgTreelist", { isValid: 1 }).then(
        (res) => {
          if (res.code === 200) {
            //当前账号绑定的机构所有下级
            let treeList = []
            this.orgTree = this.chbehavior(
              res.content,
              this.$store.state.info.orgId
            )
            if (!this.orgTree.children) {
              //当前账号绑定的机构下级&自己数据
              treeList.push({
                label: this.orgTree.label,
                orgId: this.orgTree.orgId,
              })
              this.orgTree = treeList
            } else {
              treeList.push({
                label: this.orgTree.label,
                orgId: this.orgTree.orgId,
                children: this.orgTree.children,
              })
              this.orgTree = treeList
            }
          }
        }
      )
    },
    chbehavior(arr, id) {
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },
    // 分页
    handleSizeChange(val) {
      this.query.pageSize = val
      if (this.seeShow == true) {
        this.seeState = "primary"
        this.showList(1)
      } else {
        this.seeState = "success"
        this.showList(0)
      }
    },
    handleCurrentChange(val) {
      this.query.pageNo = val
      if (this.seeShow == true) {
        this.seeState = "primary"
        this.showList(1)
      } else {
        this.seeState = "success"
        this.showList(0)
      }
    },
    // 分页1
    handleSizeChange1(val) {
      this.query1.pageSize = val
      this.showList1()
    },
    handleCurrentChange1(val) {
      this.query1.pageNo = val
      this.showList1()
    },
    // 页面刷新
    Reset() {
      this.reload()
    },
    // 上传图片
    handleAvatarSuccess(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw);
      this.$set(this.addFroms, "processPic", res.content)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg"
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!")
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!")
      }
      return isJPG && isLt2M
    },
    createExcel() {
      this.request2({
        url: "/jjyl/servicePgd/info/findServicepgdExport",
        method: "POST",
        excel: true,
        data: {
          exceptionType: 1,
          pageNo: 1,
          pageSize: -1,
          states: 7,
        },
        responseType: "blob",
      }).then((res) => {
        if (res) {
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel",
          })
          const fileName = "异常工单.xls"
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success("导出表格成功")
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
// 修改样式
/deep/.el-form-item {
  width: 100%;
  /deep/.el-form-item__label {
    width: 200px !important;
    /deep/ .el-form-item__content {
      margin-left: 200px !important;
    }
  }
}
.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }

  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}

/deep/ .search_wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f1f2f6;
  box-shadow: 0 0 6px rgba(151, 151, 151, 0.16);
  overflow: hidden;
  border-radius: 4px;
  .search_head {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .search_content {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .search_inline {
    width: 100%;
  }
  .arrowDown {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
  }
}
.searchDomw {
  cursor: pointer;
}

.card-box {
  display: flex;
}

.mapBox {
  float: left;
  margin-left: 10px;
  width: 400px !important;
  background-color: rgb(252, 249, 242);
  height: 100vh;

  div {
    width: 400px;
    height: 100%;
  }
}

.listBox {
  float: left;
  width: calc(100% - 420px);
  margin-top: 0;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.btn_group {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}

.listBox-item {
  flex-grow: 1;
  margin: 0 10px 10px 10px;
  width: calc(100% - 20px);
  overflow: hidden;

  .el-card {
    height: 100%;
  }

  .left-img {
    width: 90%;
    margin-top: 13px;
  }

  .el-timeline {
    height: 230px;
    overflow: auto;
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.cu-title2 {
  display: flex;
  align-items: center;
}

.cu-title2 > div:first-child {
  width: 80px;
  text-align: center;
}

.cu-title2 > div:nth-child(2) {
  width: calc(100% - 80px);
}

.cu-title3 {
  margin-left: 30px;
}
/deep/.cheng {
  color: #7a02ff;
}
/deep/.huang {
  color: #f402ff;
}
/deep/.hong {
  color: #ff0228;
}
/deep/.lan {
  color: #0040ff;
}
// 添加样式
.dialog_container {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e5e5e5;
  }
}

.btn {
  width: 100%;
  display: flex;
  justify-content: center;
}

.add-ent {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.add-ent > div {
  width: 48%;
}

.add-title1 {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.add-title1 > div:first-child {
  width: 120px;
  text-align: right;
}

.add-title1 > div:nth-child(2) {
  width: calc(100% - 120px);
}

.visit-image {
  width: 60%;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}

.image-title {
  width: 178px;
  margin-top: 10px;
  text-align: center;
}

.cu-title1 {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.cu-title1 > div {
  width: 50%;
}

.cu-title2 {
  display: flex;
  align-items: center;
}

.cu-title2 > div:first-child {
  width: 80px;
  text-align: center;
}

.audioActive {
  margin-left: 180px;
  margin-bottom: 20px;
}

.cu-title2 > div:nth-child(2) {
  width: calc(100% - 80px);
}

.cu-title3 {
  margin-left: 30px;
}
</style>
